import { ON_CLICK } from '../constants';
const filterGtmEvents = gtmEvents => {
  const clickEvents = [];
  const regularEvents = [];
  gtmEvents.forEach(event => {
    event.eventTrigger && event.eventTrigger === ON_CLICK ? clickEvents.push(event) : regularEvents.push(event);
  });
  return {
    clickEvents,
    regularEvents
  };
};
export default filterGtmEvents;
//# sourceMappingURL=filter-gtm-events.js.map